module.exports = __webpack_public_path__ + "static/Young-Adults-Guide__Contents-c30d15608c4fbb6164723a25e769a1bc.pdf";